import * as ROUTES from '../routes';


const Navigations = [
    {
        title: "Users",
        icon: "mdi-account-group",
        to: ROUTES.CUSTOMERS,
        mini: true,
        permissions: ['can_view_users']
    },
]

export default Navigations